import React, { useEffect, useState } from "react";
import { Table, Badge } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "../components/Common/Spinner";
import Pagination from "../components/Common/Pagination";
import { notifyError } from "../components/Common/Toaster";
import moment from "moment";
import * as XLSX from "xlsx";
import dummmyImg from "../../images/profile/images1.png";
import { getCancelledSubscriptionsList } from "../../services/UserServices/UserService";

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

function formatMs(ms) {
  if (ms == null || ms === "") return "";
  const n = Number(ms);
  if (Number.isNaN(n)) return "";
  return moment(n).format("MMM Do YYYY, h:mm A");
}

function commissionDisplay(value) {
  if (value == null || value === "") return "";
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  if (n > 0 && n <= 1) return `${(n * 100).toFixed(2)}%`;
  return `${n}%`;
}

export default function PremiumUserCancelled() {
  const location = useLocation();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [rows, setRows] = useState([]);

  const limit = 10;
  const [currentPage, setCurrentPage] = useState(
    location?.state?.page ? location?.state?.page : 0
  );
  const [search, setSearch] = useState(location?.state?.search || "");
  const [pageCount, setPageCount] = useState(0);
  const [listLength, setListLength] = useState(0);
  const [exportLoader, setExportLoader] = useState(false);

  const imgBaseURl = process.env.REACT_APP_IMAGE_BASEURL;

  useEffect(() => {
    let isActive = true;
    (async () => {
      setLoader(true);
      try {
        const response = await getCancelledSubscriptionsList(
          currentPage,
          limit,
          search
        );

        const data = response?.data?.data ?? {};
        const list = Array.isArray(data?.subscriptions)
          ? data.subscriptions
          : [];

        const total = data?.count ?? data?.total ?? list.length ?? 0;

        if (!isActive) return;
        setRows(list);
        setListLength(total);
        setPageCount(total > 0 ? Math.ceil(total / limit) : 0);
      } catch (e) {
        if (!isActive) return;
        console.error(e);
        notifyError(
          e?.response?.data?.message || "Failed to fetch subscriptions"
        );
      } finally {
        if (isActive) setLoader(false);
      }
    })();

    return () => {
      isActive = false;
    };
  }, [currentPage, search]);

  const getTableDataSearch = () => setCurrentPage(0);

  const fetchDataForExport = async () => {
    setExportLoader(true);
    try {
      const response = await getCancelledSubscriptionsList(
        currentPage,
        10000,
        search
      );
      const data = response?.data?.data ?? {};
      const list = Array.isArray(data?.subscriptions)
        ? data.subscriptions
        : [];
      setExportLoader(false);
      exportToExcel(list);
    } catch (error) {
      console.error(error);
      setExportLoader(false);
      notifyError("Failed to fetch export data");
    }
  };

  const exportToExcel = (data) => {
    const formattedData = data.map((sub) => {
      const user = sub?.app_user_id;
      const phone = `${user?.countryCode ? `+${user.countryCode} ` : ""}${
        user?.phoneNumber || user?.phone || ""
      }`.trim();

      return {
        "Contact ID": user?._id || sub?.original_app_user_id || sub?._id || "",
        Name: user?.name || "",
        Email: user?.email || "",
        "Phone Number": phone,
        Product: sub?.product_id || "",
        Store: sub?.store || "",
        "Event Type": sub?.type || "",
        Purchased: formatMs(sub?.purchased_at_ms),
        Expires: formatMs(sub?.expiration_at_ms),
        "Record Created": sub?.createdAt
          ? moment(sub.createdAt).format("MMM Do YYYY, h:mm A")
          : "",
      };
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Refunded Members");

    XLSX.writeFile(workbook, "Refunded-Members.xlsx");
  };

  return (
    <div className="default-tab">
          <div className="row g-3 align-items-center mb-3">
            <div className="col-12 col-md-6 col-lg-3 ms-auto">
              {exportLoader ? (
                <button className="btn btn-primary w-100 py-3" disabled>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  />
                  Exporting...
                </button>
              ) : (
                <button
                  className="btn btn-primary w-100 py-3"
                  onClick={() => fetchDataForExport()}
                >
                  Export <i className="flaticon-381-send"></i>
                </button>
              )}
            </div>
          </div>

          {loader ? (
            <Spinner />
          ) : (
            <Table responsive className="mostly-customized-scrollba">
              <thead style={{ color: "black" }}>
                <tr>
                  <th>
                    <strong>Image</strong>
                  </th>
                  <th>
                    <strong>NAME</strong>
                  </th>
                  <th>
                    <strong>EMAIL</strong>
                  </th>
                  <th>
                    <strong>PHONE</strong>
                  </th>
                  <th>
                    <strong>Product</strong>
                  </th>
                  <th>
                    <strong>Store</strong>
                  </th>
                  <th>
                    <strong>Event type</strong>
                  </th>
                  <th>
                    <strong>Purchased</strong>
                  </th>
                  <th>
                    <strong>Expires</strong>
                  </th>
                  <th>
                    <strong>Record created</strong>
                  </th>
                  {/* <th>
                    <strong>Action</strong>
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {rows?.map((sub, idx) => {
                  const user = sub?.app_user_id;
                  const userId =
                    user?._id || sub?.original_app_user_id || sub?._id;

                  const img = user?.images?.[0];
                  const imageSrc = img?.type === "video"
                    ? imgBaseURl + img?.thumbnailUrl
                    : img?.type === "image"
                      ? imgBaseURl + img?.url
                      : img?.url
                        ? imgBaseURl + img.url
                        : dummmyImg;

                  const phone =
                    user?.countryCode
                      ? `+${user?.countryCode} `
                      : "";
                  const phoneRest = user?.phoneNumber || user?.phone || "";

                  return (
                    <tr
                      key={sub._id || idx}
                      style={{ cursor: "pointer",fontSize: "14px" }}
                      className="pointer"
                      onClick={() =>
                        userId &&
                        navigate("/member-details", {
                          state: {
                            data: userId,
                            userName: user?.name,
                            selectedTab: "Refunded Members",
                            search,
                            page: currentPage,
                          },
                        })
                      }
                    >
                      <td onClick={(e) => e.stopPropagation()}>
                        <img
                          src={imageSrc}
                          alt=""
                          width={100}
                          height={80}
                          className="rounded"
                        />
                      </td>
                      <td>{user?.name || "-"}</td>
                      <td>{user?.email || "-"}</td>
                      <td>
                        {phone}
                        {phoneRest || "-"}
                      </td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {sub?.product_id || "-"}
                      </td>
                      <td>
                        {sub?.store ? (
                          <Badge bg="" className="badge-info light">
                            {sub.store}
                          </Badge>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        {sub?.type ? (
                          <Badge bg="" className="badge-secondary">
                            {sub.type}
                          </Badge>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>{formatMs(sub?.purchased_at_ms)}</td>
                      <td>{formatMs(sub?.expiration_at_ms)}</td>
                      <td>
                        {sub?.createdAt
                          ? moment(sub.createdAt).format(
                              "MMM Do YYYY, h:mm A"
                            )
                          : ""}
                      </td>
                      {/* <td
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                      >
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="info light"
                            className="light sharp btn btn-info i-false"
                          >
                            {svg1}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {userId ? (
                              <Dropdown.Item
                                onClick={() => {
                                  navigate("/chat", {
                                    state: {
                                      data: userId,
                                      selectedTab: "Cancelled Members",
                                      userName: user?.name,
                                      search,
                                      page: currentPage,
                                      gender: user?.gender,
                                      type: "table",
                                      userType: "member",
                                    },
                                  });
                                }}
                              >
                                Chat
                              </Dropdown.Item>
                            ) : null}
                          </Dropdown.Menu>
                        </Dropdown>
                      </td> */}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}

          {!loader && rows?.length === 0 && (
            <div className="justify-content-center d-flex my-5">
              Sorry, Data Not Found!
            </div>
          )}

          {!loader && rows?.length !== 0 && (
            <div className="card-footer clearfix">
              <div className="d-block d-sm-flex justify-content-between align-items-center">
                <div className="dataTables_info">
                  Showing {listLength === 0 ? 0 : currentPage * limit + 1} to{" "}
                  {listLength > (currentPage + 1) * limit
                    ? (currentPage + 1) * limit
                    : listLength}{" "}
                  of {listLength} entries
                </div>
                <Pagination
                  pageCount={pageCount}
                  pageValue={currentPage}
                  setPage={setCurrentPage}
                />
              </div>
            </div>
          )}
    </div>
  );
}
